import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Localização',
        path: '/biblioteca/biblocalizacao',
        name: 'biblocalizacao',
        component: () => import('@/views/biblioteca/biblocalizacao/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_LOCALIZACAOFISICAOBRASNOVO_MENU_1300801599],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Localização',
        path: '/biblioteca/biblocalizacao/cadastro/:id?',
        parent: 'biblocalizacao',
        name: 'biblocalizacao_create',
        component: () => import('@/views/biblioteca/biblocalizacao/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_LOCALIZACAOFISICAOBRASNOVO_MENU_1300801599],
        },
        goesToMenu: true,
    },
]
